// ─── API ──────────────────────────────────────────────────────────────────────

export const API_BASE = 'https://tbl.zerdegroup.kz/api/v1';

// ─── Table Layout ─────────────────────────────────────────────────────────────

/**
 * CSS grid-template-columns для строк журнала.
 * 19 колонок: № | Аптека | Регион | Наименование | Производитель | Срок |
 *             Серия | Кол уп | Кол шт | Цена | Сумма | Менеджер | Категория |
 *             Цен.группа | Код | ШК | Комментарий | Дата записи | Кем создан
 */
export const GRID_TEMPLATE_COLUMNS =
  '44px 80px 100px minmax(160px,1.5fr) minmax(120px,1fr) 100px 96px 80px 80px 90px 100px 110px 110px 110px 90px 110px 120px 108px 100px';

export const MIN_TABLE_WIDTH = 2000;

// ─── Pagination ───────────────────────────────────────────────────────────────

export const DEFAULT_PAGE_LIMIT = 50;

// ─── Analytics ────────────────────────────────────────────────────────────────

/** Количество аптек в топе для диаграммы распределения */
export const TOP_N = 10;
